export default __webpack_public_path__ + "b6e6034.png";